import { render, staticRenderFns } from "./ManageAnswer.vue?vue&type=template&id=e0629996&"
import script from "./ManageAnswer.vue?vue&type=script&lang=js&"
export * from "./ManageAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports